import React from 'react'

const Footer = () => {
    return (
        <div className="container footer ran-footer">
               © 2024 - <b><a href="https://www.facebook.com/YogaRANOnlineClassicOfficial" rel="noreferrer" target="_blank">Yoga RAN Online Classic</a></b> | Powered by <b><a href="https://www.facebook.com/khleasec" rel="noreferrer" target="_blank">KHLEA</a></b>
        </div>
    )
}

export default Footer
